import { render, staticRenderFns } from "./Scorebar.vue?vue&type=template&id=8fd0313a&"
import script from "./Scorebar.vue?vue&type=script&lang=js&"
export * from "./Scorebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports